<template>
  <div
    style="padding: 15px"
    class="bg-white"
    label-position="top"
    v-loading="isLoading"
  >
    <el-row :gutters="15">
      <el-col :sm="12">
        <h4 class="form-title">Damage Report</h4>
      </el-col>
      <el-col :sm="12">
        <div class="text-right">
          <el-button type="primary" size="small" @click="dialogView = true">
            Filter <span class="el-icon-search"></span>
          </el-button>
        </div>
      </el-col>
    </el-row>
    <el-dialog ref="dialog" :visible.sync="dialogView" title="Report Filter">
      <el-form label-position="left" label-width="120px">
        <el-form-item label="ULD Type/Desc.">
            <el-select v-model="uld_type" clearable filterable>
              <el-option
                v-for="d in descriptions"
                :value="d.value"
                :key="d.value"
                :label="d.text"
              ></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="Manufacturer">
          <el-select
            v-model="manufacturer"
            placeholder="Select Manufacturer here"
            clearable
            filterable
          >
            <el-option
                  v-for="d in manufacturer_list.data"
                  :value="d.id"
                  :key="d.id"
                  :label="d.name"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item v-if="!isDaily" label="Customers">
          <el-select
            v-model="customer"
            placeholder="Select Customer here"
            clearable
            filterable
          >
            <el-option
                  v-for="d in customer_list"
                  :value="d.value"
                  :key="d.value"
                  :label="d.text"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Date Range">
          <el-date-picker
            v-model="date_range"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="To"
            start-placeholder="Start date"
            end-placeholder="End date"
          >
          </el-date-picker>
        </el-form-item>
        <el-button type="primary" :disabled="btnDisable" @click="generate">Generate Report</el-button>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/api";
import ULD from "@/models/ULD";
import Manufacturer from "@/models/Manufacturer";
import Masterlist from "@/models/Masterlist";
import moment from "moment";
// import Part from "@/models/Part";
export default {
  name: "DamageReport",
  computed: {
    suppliers() {
      return this.$store.getters["supplier/glossary"];
    },
    report_url() {
      let url = `/api/v1/inventory/download_inventory/?`;
      if (this.pager.supplier_id) {
        url += `&supplier_id=${this.pager.supplier_id}`;
      }
      if (this.pager.item_type) {
        url += `&item_type=${this.pager.item_type}`;
      }

      return url;
    }
  },
  data() {
    return {
      list: { data: [], paging: {} },
      descriptions: Masterlist.descriptions(),
      parts: [],
      date_range: "",
      is_cost_summary: 0,
      isDaily: false,
      manufacturer_list: [],
      manufacturer: "",
      uld_type: "",
      pager: {
        page: 1,
        limit: 25,
        search: "",
        supplier_id: "",
        item_type: "",
      },
      dialogView: false,
      dType: "month",
      dPlaceholder: "Pick a month",
      value1: "",
      customer: "",
      report: "",
      customer_list: [],
      btnDisable: false,
      isLoading: true,
      report_list: [
            {
                value: "Daily Production Report",
                label: 0
            },
            {
                value: "Monthly Production Report",
                label: 1
            },
            {
                value: "Monthly Repair Cost Summary",
                label: 2
            },
            {
                value: "Yearly Production Report",
                label: 3
            }
      ],
    };
  },
  methods: {
    customers_data() {
        ULD.customers_data().then(list => {
            this.customer_list = list;
        });
    },
    manufacturers() {
      Manufacturer.list(1).then(list => {
        this.manufacturer_list = list;
      });
    },
    generate() {     
        let date_from = "";
        let date_to = "";
        if (this.date_range && this.date_range.length > 1) {
             date_from = moment(this.date_range[0]);
             date_to = moment(this.date_range[1]);
        }
        let customer_id = this.customer;
        var reportInfo = {
            name: "Damage Report",
            ext: ".xlsx"
        };
        this.isLoading = true;
        this.btnDisable = true;
        let url = `/api/v1/repair/damage_trend/?customer_id=${customer_id}&date_from=${date_from.format("YYYY-MM-DD")}&date_to=${date_to.format("YYYY-MM-DD")}&manufacturer=${this.manufacturer}&uld_type=${this.uld_type}`
        console.log(url);
        api.download(url, reportInfo).then(() => {
            this.isLoading = false;
            this.btnDisable = false;
        });
        this.isLoading = false;
        this.btnDisable = false;

    },
    setReportFilter() {
        if(this.report === 'Daily Production Report') {
            this.is_cost_summary = 3;
            this.isDaily = true;
            this.dType = 'date';
            this.dPlaceholder = "Pick a day";
            return false;
        } 
        if(this.report === 'Monthly Repair Cost Summary') {
            this.is_cost_summary = 1;
            return false;
        } 
        if(this.report === 'Yearly Production Report') {
            this.is_cost_summary = 2;
            return false;
        }
        this.dType = 'month';
        this.dPlaceholder = "Pick a month";
        this.is_cost_summary = 0;
        this.isDaily = false;
        this.value1 = null;
    }

  },
  mounted() {
    this.dialogView = false;
    this.isLoading = false;
    this.customers_data();
    this.manufacturers();
    // Part.getGlossary().then(list => {
    //   this.parts = list;
    // });
  }
};
</script>

<style lang="css" scoped></style>
